import * as React from 'react';
import Svg, {G, Path, Defs, ClipPath, SvgProps} from 'react-native-svg';

type Props = SvgProps & {
  size?: number;
  color?: string;
};

const GoBackSvg: React.FC<Props> = ({size = 24, color = '#0C1D2E', ...props}) => {
  const height = size;
  const width = (8 / 14) * height;
  const strokeWidth = (2 / 14) * height;

  return (
    <Svg width={width} height={height} viewBox='0 0 8 14' fill='none' {...props}>
      <G clipPath='url(#a)'>
        <Path
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={strokeWidth}
          d='M7 13 1 7l6-6'
        />
      </G>
      <Defs>
        <ClipPath id='a'>
          <Path fill='#fff' d='M0 0h8v14H0z' />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default GoBackSvg;
